import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		fileName: {
			color: theme.palette.grey[800],
		},
		container: {
			display: 'flex',
			flexDirection: 'column',
		},
		cvWrap: {
			position: 'relative',
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center',
			flexFlow: 'row',
			margin: '20px 0px',
			'& img': {
				margin: '30px 0px',
			},
			background: '#ebebeb',
			borderRadius: '8px',
			paddingLeft: '10px',
			paddingRight: '10px',
			height: '80px',
		},
		cvFile: {
			display: 'flex',
			alignItems: 'center',
			flexFlow: 'row',
			flex: '1',
		},
		actionButtons: {
			display: 'flex',
			flexDirection: 'row',
			flex: '1',
			justifyContent: 'flex-end',
		},
		uploadFileLoader: {
			flex: '1',
		},
		uploadNewBtn: {
			fontWeight: 700,
			fontSize: 10,
			// backgroundColor: theme.palette.secondary.main,
			textTransform: 'none',
			marginLeft: '8px',
		},
		deleteRootElement: {
			backgroundColor: 'unset !important',
			marginRight: 10,
		},

		editIconLabel: {
			marginRight: '-14px',
		},
	})
